import FrameComponent7 from "../components/FrameComponent7";
import DarkFooter from "../components/DarkFooter";
import FrameComponent8 from "../components/FrameComponent8";
import TestTable from "../components/TestTable";
import { Container } from '@/components/ui/container';
import { Stack } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

const AfterLogin = () => {
  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-background z-0" />
      <div className="absolute inset-0 bg-gradient-to-tr from-primary/10 to-transparent z-0" />
      <div className="absolute inset-0 bg-gradient-to-bl from-primary/5 to-transparent z-0" />
      <img
        className="absolute top-0 left-0 w-full h-auto opacity-20 z-0"
        alt=""
        src="/grid-top-zero-height@2x.png"
      />
      
      <div className="relative z-10">
        <FrameComponent7 />
        <FrameComponent8 />
        <DarkFooter />
        
        <Container>
          <Stack spacing="lg" align="center" className="text-center py-12 my-8">
            <Heading level="h2" className="text-3xl md:text-4xl font-bold">
              Track Your Progress with the Latest Screening Test Results
            </Heading>
            <Text size="lg" variant="muted" className="max-w-2xl">
              Review your recent screening tests and track your performance to
              better understand your progress and areas for improvement.
            </Text>
          </Stack>
          
          <div className="my-8">
            <TestTable />
          </div>
        </Container>
        
        <img
          className="absolute bottom-0 right-0 w-64 h-auto opacity-30 z-0"
          loading="lazy"
          alt=""
          src="/humanoid-robot-eavesdropping-vector-cartoon-character 1.png"
        />
      </div>
    </div>
  );
};

export default AfterLogin;
